import { StripeCheckoutForm } from './stripe-checkout-form';
import { ComponentChildren } from 'preact';
import { CouponRow, PriceRow } from 'server/types';
import { PurchaseFn, StripeHandlerFn } from 'shared/payments/types';
import { useIntl } from 'shared/intl/use-intl';
import * as pmtmath from 'shared/payments/math';
import { CheckoutForm } from './checkout-form';
import { TrustStrip } from './trust-strip';
import { useEffect } from 'preact/hooks';
import { isUpsellable } from './upsell-stripe-checkout-form';
import { rpx } from 'client/lib/rpx-client';

/**
 * Display the forms for actually making the purchase during the checkout process.
 */
export function PurchaseForm(props: {
  collectAddress: boolean;
  price: PriceRow;
  coupon?: CouponRow;
  autoSubmit?: boolean;
  handleStripe?: StripeHandlerFn;
  beginPurchase: PurchaseFn;
  onPurchaseComplete(): Promise<unknown>;
  isGift?: boolean;
  footer?: ComponentChildren;
}) {
  const { price, coupon } = props;
  const intl = useIntl();

  useEffect(() => {
    if (isUpsellable(price)) {
      rpx.myCorePayments.trackUpsellBounces({ priceId: price.id }).catch(console.error);
    }
  }, []);

  if (pmtmath.isFree({ price, coupon })) {
    return (
      <CheckoutForm
        actionText={intl('Finish Checkout →')}
        belowButton={<TrustStrip />}
        onSubmit={() => props.beginPurchase({}).then(props.onPurchaseComplete)}
        autoSubmit={props.autoSubmit}
      >
        {props.footer}
      </CheckoutForm>
    );
  }

  return (
    <div class="flex flex-col gap-4">
      <StripeCheckoutForm {...props} />
      {props.footer}
    </div>
  );
}
